
import React from 'react';

import './css/style.css'
import cv from './filip-walter-cv.pdf'

import arrDown from './images/arrow_down.png';
import arrPrev from './images/arrow_prev.png';
import arrNext from './images/arrow_next.png';
import closeCross from './images/close_cross.png';
import decoded from './images/decoded.jpg';
import profile from './images/profile.png';
import web_2004 from './images/web_2004.jpg';
import web_2011 from './images/web_2011.jpg';

import img001 from './portfolio/001.jpg';
import img002 from './portfolio/002.jpg';
import img003 from './portfolio/003.jpg';
import img004 from './portfolio/004.jpg';
import img005 from './portfolio/005.jpg';
import img006 from './portfolio/006.jpg';
import img007 from './portfolio/007.jpg';
import img008 from './portfolio/008.jpg';
import img009 from './portfolio/009.jpg';
import img010 from './portfolio/010.jpg';
import img011 from './portfolio/011.jpg';
import img012 from './portfolio/012.jpg';
import img013 from './portfolio/013.jpg';
import img014 from './portfolio/014.jpg';
import img015 from './portfolio/015.jpg';
import img016 from './portfolio/016.jpg';
import img017 from './portfolio/017.jpg';
import img018 from './portfolio/018.jpg';
import img019 from './portfolio/019.jpg';
import img020 from './portfolio/020.jpg';
import img021 from './portfolio/021.jpg';
import img022 from './portfolio/022.jpg';
import img023 from './portfolio/023.jpg';
import img024 from './portfolio/024.jpg';
import img025 from './portfolio/025.jpg';
import img026 from './portfolio/026.jpg';
import img027 from './portfolio/027.jpg';
import img028 from './portfolio/028.jpg';
import img029 from './portfolio/029.jpg';
import img030 from './portfolio/030.jpg';
import img031 from './portfolio/031.jpg';
import img032 from './portfolio/032.jpg';
import img033 from './portfolio/033.jpg';
import img034 from './portfolio/034.jpg';
import img035 from './portfolio/035.jpg';
import img036 from './portfolio/036.jpg';
import img037 from './portfolio/037.jpg';
import img038 from './portfolio/038.jpg';
import img039 from './portfolio/039.jpg';
import img040 from './portfolio/040.jpg';
import img041 from './portfolio/041.jpg';
import img042 from './portfolio/042.jpg';
import img043 from './portfolio/043.jpg';
import img044 from './portfolio/044.jpg';
import img045 from './portfolio/045.jpg';
import img046 from './portfolio/046.jpg';
import img047 from './portfolio/047.jpg';
import img048 from './portfolio/048.jpg';
import img049 from './portfolio/049.jpg';
import img050 from './portfolio/050.jpg';
import img051 from './portfolio/051.jpg';
import img052 from './portfolio/052.jpg';
import img053 from './portfolio/053.jpg';
import img054 from './portfolio/054.jpg';
import img055 from './portfolio/055.jpg';
import img056 from './portfolio/056.jpg';
import img057 from './portfolio/057.jpg';
import img058 from './portfolio/058.jpg';
import img059 from './portfolio/059.jpg';
import img060 from './portfolio/060.jpg';
import img061 from './portfolio/061.jpg';
import img062 from './portfolio/062.jpg';
import img063 from './portfolio/063.jpg';
import img064 from './portfolio/064.jpg';
import img065 from './portfolio/065.jpg';
import img066 from './portfolio/066.jpg';
import img067 from './portfolio/067.jpg';
import img068 from './portfolio/068.jpg';
import img069 from './portfolio/069.jpg';
import img070 from './portfolio/070.jpg';
import img071 from './portfolio/071.jpg';
import img072 from './portfolio/072.jpg';
import img073 from './portfolio/073.jpg';
import img074 from './portfolio/074.jpg';
import img075 from './portfolio/075.jpg';
import img076 from './portfolio/076.jpg';
import img077 from './portfolio/077.jpg';
import img078 from './portfolio/078.jpg';
import img079 from './portfolio/079.jpg';
import img080 from './portfolio/080.jpg';
import img081 from './portfolio/081.jpg';
import img082 from './portfolio/082.jpg';
import img083 from './portfolio/083.jpg';
import img084 from './portfolio/084.jpg';
import img085 from './portfolio/085.jpg';
import img086 from './portfolio/086.jpg';
import img087 from './portfolio/087.jpg';
import img088 from './portfolio/088.jpg';
import img089 from './portfolio/089.jpg';
import img090 from './portfolio/090.jpg';
import img091 from './portfolio/091.jpg';
import img092 from './portfolio/092.jpg';
import img093 from './portfolio/093.jpg';
import img094 from './portfolio/094.jpg';
import img095 from './portfolio/095.jpg';
import img096 from './portfolio/096.jpg';
import img097 from './portfolio/097.jpg';
import img098 from './portfolio/098.jpg';
import img099 from './portfolio/099.jpg';
import img100 from './portfolio/100.jpg';
import img101 from './portfolio/101.jpg';
import img102 from './portfolio/102.jpg';
import img103 from './portfolio/103.jpg';

export default function Web2018() {
  return (
    <>
      <div className="header-container">
        <header>
          <a href="#portfolio" className="portfolio-header header-section-active">
            <p className="header-heading"><b>Filip Walter</b> - freelance graphic designer</p>
            <p className="header-section-portfolio">portfolio</p>
            <img src={arrDown} alt="" className="nav-arrow nav-arrow-right" />
          </a>
          <a href="#about" className="about-header">
            <p className="header-section-about">about me</p>
            <img src={arrDown} alt="" className="nav-arrow nav-arrow-left" />
          </a>
        </header>
      </div>
      <main>
        <section id="portfolio">
          <div className="portfolio-gallery">
            <img src={img001} alt="" className="image-list-item" />
            <img src={img002} alt="" className="image-list-item" />
            <img src={img003} alt="" className="image-list-item" />
            <img src={img004} alt="" className="image-list-item" />
            <img src={img005} alt="" className="image-list-item" />
            <img src={img006} alt="" className="image-list-item" />
            <img src={img007} alt="" className="image-list-item" />
            <img src={img008} alt="" className="image-list-item" />
            <img src={img009} alt="" className="image-list-item" />
            <img src={img010} alt="" className="image-list-item" />
            <img src={img011} alt="" className="image-list-item" />
            <img src={img012} alt="" className="image-list-item" />
            <img src={img013} alt="" className="image-list-item" />
            <img src={img014} alt="" className="image-list-item" />
            <img src={img015} alt="" className="image-list-item" />
            <img src={img016} alt="" className="image-list-item" />
            <img src={img017} alt="" className="image-list-item" />
            <img src={img018} alt="" className="image-list-item" />
            <img src={img019} alt="" className="image-list-item" />
            <img src={img020} alt="" className="image-list-item" />
            <img src={img021} alt="" className="image-list-item" />
            <img src={img022} alt="" className="image-list-item" />
            <img src={img023} alt="" className="image-list-item" />
            <img src={img024} alt="" className="image-list-item" />
            <img src={img025} alt="" className="image-list-item" />
            <img src={img026} alt="" className="image-list-item" />
            <img src={img027} alt="" className="image-list-item" />
            <img src={img028} alt="" className="image-list-item" />
            <img src={img029} alt="" className="image-list-item" />
            <img src={img030} alt="" className="image-list-item" />
            <img src={img031} alt="" className="image-list-item" />
            <img src={img032} alt="" className="image-list-item" />
            <img src={img033} alt="" className="image-list-item" />
            <img src={img034} alt="" className="image-list-item" />
            <img src={img035} alt="" className="image-list-item" />
            <img src={img036} alt="" className="image-list-item" />
            <img src={img037} alt="" className="image-list-item" />
            <img src={img038} alt="" className="image-list-item" />
            <img src={img039} alt="" className="image-list-item" />
            <img src={img040} alt="" className="image-list-item" />
            <img src={img041} alt="" className="image-list-item" />
            <img src={img042} alt="" className="image-list-item" />
            <img src={img043} alt="" className="image-list-item" />
            <img src={img044} alt="" className="image-list-item" />
            <img src={img045} alt="" className="image-list-item" />
            <img src={img046} alt="" className="image-list-item" />
            <img src={img047} alt="" className="image-list-item" />
            <img src={img048} alt="" className="image-list-item" />
            <img src={img049} alt="" className="image-list-item" />
            <img src={img050} alt="" className="image-list-item" />
            <img src={img051} alt="" className="image-list-item" />
            <img src={img052} alt="" className="image-list-item" />
            <img src={img053} alt="" className="image-list-item" />
            <img src={img054} alt="" className="image-list-item" />
            <img src={img055} alt="" className="image-list-item" />
            <img src={img056} alt="" className="image-list-item" />
            <img src={img057} alt="" className="image-list-item" />
            <img src={img058} alt="" className="image-list-item" />
            <img src={img059} alt="" className="image-list-item" />
            <img src={img060} alt="" className="image-list-item" />
            <img src={img061} alt="" className="image-list-item" />
            <img src={img062} alt="" className="image-list-item" />
            <img src={img063} alt="" className="image-list-item" />
            <img src={img064} alt="" className="image-list-item" />
            <img src={img065} alt="" className="image-list-item" />
            <img src={img066} alt="" className="image-list-item" />
            <img src={img067} alt="" className="image-list-item" />
            <img src={img068} alt="" className="image-list-item" />
            <img src={img069} alt="" className="image-list-item" />
            <img src={img070} alt="" className="image-list-item" />
            <img src={img071} alt="" className="image-list-item" />
            <img src={img072} alt="" className="image-list-item" />
            <img src={img073} alt="" className="image-list-item" />
            <img src={img074} alt="" className="image-list-item" />
            <img src={img075} alt="" className="image-list-item" />
            <img src={img076} alt="" className="image-list-item" />
            <img src={img077} alt="" className="image-list-item" />
            <img src={img078} alt="" className="image-list-item" />
            <img src={img079} alt="" className="image-list-item" />
            <img src={img080} alt="" className="image-list-item" />
            <img src={img081} alt="" className="image-list-item" />
            <img src={img082} alt="" className="image-list-item" />
            <img src={img083} alt="" className="image-list-item" />
            <img src={img084} alt="" className="image-list-item" />
            <img src={img085} alt="" className="image-list-item" />
            <img src={img086} alt="" className="image-list-item" />
            <img src={img087} alt="" className="image-list-item" />
            <img src={img088} alt="" className="image-list-item" />
            <img src={img089} alt="" className="image-list-item" />
            <img src={img090} alt="" className="image-list-item" />
            <img src={img091} alt="" className="image-list-item" />
            <img src={img092} alt="" className="image-list-item" />
            <img src={img093} alt="" className="image-list-item" />
            <img src={img094} alt="" className="image-list-item" />
            <img src={img095} alt="" className="image-list-item" />
            <img src={img096} alt="" className="image-list-item" />
            <img src={img097} alt="" className="image-list-item" />
            <img src={img098} alt="" className="image-list-item" />
            <img src={img099} alt="" className="image-list-item" />
            <img src={img100} alt="" className="image-list-item" />
            <img src={img101} alt="" className="image-list-item" />
            <img src={img102} alt="" className="image-list-item" />
            <img src={img103} alt="" className="image-list-item" />
          </div>
        </section>
        <section id="about" className="about-content">
          <div className="about-profile">
            <img src={profile} alt="Filip Walter profile photo" />
          </div>
          <div className="about-info">
            <div className="about-text">
              <h1>Filip Walter</h1>
              <p>Hello, :-) <br />
                I am a freelance graphic designer, living and working in Prague. If you like my work and need help with
                something, don´t hesitate to contact me.
              </p>
              <p>
                E-mail: <a href="mailto:info@filipwalter.cz"><span>info@filipwalter.cz</span></a><br />
                Mobile: <span>+420 737 06 06 20</span><br />
                Skype: <span>filipwalter</span><br />
              </p>
              <a href={cv} target="_blank" className="cv">
                Download CV
              </a>
            </div>
            <ul className="references">
              <li>
                <a href="http://www.filipwalter.cz/decoded" target="_blank">
                  <img src={decoded} alt="" />
                  <p>Tomáš Walter - Decoded <br />
                    <span>(Flash Website)</span>
                  </p>
                </a>
              </li>
              <li>
                <a href="http://www.filipwalter.cz/2011" target="_blank">
                  <img src={web_2011} alt="" />
                  <p>Filip Walter - 2011 <br />
                    <span>(Flash Website)</span>
                  </p>
                </a>
              </li>
              <li>
                <a href="http://www.filipwalter.cz/2004" target="_blank">
                  <img src={web_2004} alt="" />
                  <p>Filip Walter - 2004 <br />
                    <span>(Flash Website)</span>
                  </p>
                </a>
              </li>
            </ul>
          </div>
        </section>
      </main>
      <div className="modal-window">
        <div className="modal-bg"></div>
        <div className="modal-content-bg">
          <div className="modal-content-container">
            <div className="modal-image">

            </div>
            <div className="close"><img src={closeCross} alt="previous" /></div>
            <div className="arrow arrow-prev"><img src={arrPrev} alt="previous" /></div>
            <div className="arrow arrow-next"><img src={arrNext} alt="next" /></div>
          </div>
        </div>
      </div>
    </>
  )
}